import React from 'react';
import { Link } from 'react-router-dom';
import { formatDistance } from '../../utils/distance';

const API_IMAGE = process.env.REACT_APP_IMAGE_URL || '';

const imageUrl = (value) => {
  if (!value) return null;
  if (/^https?:\/\//i.test(value)) return value;
  return `${API_IMAGE}${value.startsWith('/') ? '' : '/'}${value}`;
};

function MerchantCard({ merchant }) {
  const banner = imageUrl(merchant.store_banner || merchant.business_logo);
  const distance = formatDistance(merchant.distance_km);
  const isMarketing = merchant.service_type === 'marketing';

  return (
    <Link
      to={`/store/${merchant.subdomain}`}
      className="tap-card group block overflow-hidden rounded-[1.5rem] border border-black/5 bg-white shadow-[0_10px_35px_rgba(33,24,19,0.08)] sm:rounded-[1.75rem] lg:hover:shadow-[0_24px_70px_rgba(33,24,19,0.14)]"
    >
      <div className="relative h-48 overflow-hidden bg-gradient-to-br from-[#40231f] via-[#8f4438] to-[#e5a461] sm:h-56">
        {banner && <img src={banner} alt="" className="h-full w-full object-cover transition duration-700 group-hover:scale-105" />}
        <div className="absolute inset-0 bg-gradient-to-t from-black/65 via-black/5 to-transparent" />
        {merchant.is_featured && <span className="absolute left-4 top-4 rounded-full bg-white/90 px-3 py-1.5 text-[10px] font-black uppercase tracking-[0.14em] text-[#502e28] backdrop-blur sm:left-5 sm:top-5">Featured</span>}
        <span className="absolute bottom-5 right-5 rounded-full border border-white/25 bg-black/20 px-3 py-1.5 text-xs font-semibold text-white backdrop-blur-md">
          {isMarketing ? 'View products →' : 'View menu →'}
        </span>
      </div>
      <div className="p-5 sm:p-6">
        <div className="flex items-start justify-between gap-4">
          <div>
            <h3 className="font-playfair-display text-[1.35rem] font-bold leading-tight text-[#211915] sm:text-2xl">{merchant.business_name}</h3>
            <p className="mt-1 text-sm text-gray-500">{merchant.business_type || 'Restaurant'} · {merchant.business_address || 'Available online'}</p>
            <span className="mt-3 inline-flex rounded-full bg-[#f7eee8] px-3 py-1 text-[10px] font-bold uppercase tracking-[0.14em] text-[#6f342e]">
              {isMarketing ? 'Contact merchant' : 'Order online'}
            </span>
            {distance && <p className="mt-2 text-xs font-bold uppercase tracking-[0.12em] text-[#8a4b3e]">{distance}</p>}
          </div>
          <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-[#f7eee8] text-[#6f342e]">↗</div>
        </div>
        <p className="mt-4 line-clamp-2 text-sm leading-6 text-gray-600">{merchant.store_description || 'Thoughtfully prepared meals, ready when you are.'}</p>
      </div>
    </Link>
  );
}

export default MerchantCard;
